import versionMapper from './versionMapper';
import latestReleases from './latestReleases';

const validate = (isUpdatedVersion, fieldType, version) =>
  !isUpdatedVersion ||
  (isUpdatedVersion && version.number !== latestReleases[fieldType]);

export default (data) => {
  const { fieldData, fieldType, userPreferences, defaultVal, formatType } =
    data || {};

  if (fieldData) {
    const parsedFieldData = JSON.parse(fieldData);

    const {
      document: { data: documentData },
    } = parsedFieldData;
    const { version } = documentData;

    const isUpdatedVersion = version && version.updated;

    if (validate(isUpdatedVersion, fieldType, version))
      return versionMapper({
        ...data,
        currentVersion: version,
        fieldData: parsedFieldData,
      });
    /**
     * * Here, add the respective version we need to hit for the next releases and from which version it is coming from
     * * For example:- if(isUpdated && version.updated !== 4 && version.updated === 2)
     */
    return { [fieldType]: parsedFieldData };
  }
  if (fieldType === 'userPreferences') {
    const { version } = userPreferences;
    const isUpdatedVersion = version && version.updated;

    if (validate(isUpdatedVersion, fieldType, version)) {
      return versionMapper({
        ...data,
        currentVersion: version,
        userPreferences,
        formatType,
      });
    }
    return userPreferences;
  }

  return {
    [fieldType]: defaultVal[fieldType],
  };
};
